import React, { useState, useEffect } from "react";
import { getCart, updateCartItemQuantity, removeFromCart } from "../utils/cartUtils";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const cart = getCart();
        setCartItems(cart.items || []);
    }, []);

    const increaseQuantity = (id) => {
        const item = cartItems.find((item) => item.id === id);
        if (item) {
            updateCartItemQuantity(id, item.quantity + 1);
            setCartItems(cartItems.map((item) =>
                item.id === id ? { ...item, quantity: item.quantity + 1 } : item
            ));
        }
    };

    const decreaseQuantity = (id) => {
        const item = cartItems.find((item) => item.id === id);
        if (item && item.quantity > 1) {
            updateCartItemQuantity(id, item.quantity - 1);
            setCartItems(cartItems.map((item) =>
                item.id === id ? { ...item, quantity: item.quantity - 1 } : item
            ));
        } else if (item && item.quantity === 1) {
            removeFromCart(id);
            setCartItems(cartItems.filter((item) => item.id !== id));
            toast.info("Item removed from cart", {
                position: "top-right",
                autoClose: 2000,
            });
        }
    };

    const handleCheckout = () => {
        navigate("/checkout");
    };

    const subtotal = cartItems
        .reduce((sum, item) => sum + parseFloat(item.price) * item.quantity, 0)
        .toFixed(2);
    const delivery = 5.0;
    const discount = 0.0;
    const total = (parseFloat(subtotal) + delivery - discount).toFixed(2);

    return (
        <section className="py-10">
            <div className="container mx-auto">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold">Order</h1>
                    <div className="flex items-center gap-2 bg-[#e0f7fa] text-[#20bcb4] py-2 px-4 rounded-full">
                        <span>${total}</span>
                        <img src={require("../../assets/icons/cart.svg").default} alt="cart" className="w-5 h-5" />
                    </div>
                </div>

                {cartItems.length === 0 ? (
                    <div className="text-center py-10">Your cart is empty.</div>
                ) : (
                    <>
                        <div className="flex flex-col gap-4">
                            {cartItems.map((item) => (
                                <div key={item.id} className="flex items-center bg-white p-4 rounded-lg shadow-[0_0_10px_#0000001a] gap-4">
                                    <div className="w-[20%]">
                                        <img
                                            className="w-full h-full rounded-full"
                                            src={item.image}
                                            alt={item.name}
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <div className="text-lg font-bold capitalize">{item.name}</div>
                                        <div className="flex items-center justify-between mt-2">
                                            <div className="font-bold">${item.price}</div>
                                            <div className="flex items-center gap-2">
                                                <button
                                                    onClick={() => decreaseQuantity(item.id)}
                                                    className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full"
                                                >
                                                    <span className="text-lg">-</span>
                                                </button>
                                                <span>{item.quantity}</span>
                                                <button
                                                    onClick={() => increaseQuantity(item.id)}
                                                    className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full"
                                                >
                                                    <span className="text-lg">+</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mt-6 p-4 border border-[#20bcb4] rounded-lg">
                            <div className="flex justify-between mb-2">
                                <span>Subtotal</span>
                                <span>${subtotal}</span>
                            </div>
                            <div className="flex justify-between mb-2">
                                <span>Discount</span>
                                <span>${discount.toFixed(2)}</span>
                            </div>
                            <div className="flex justify-between mb-2">
                                <span>Delivery</span>
                                <span>${delivery.toFixed(2)}</span>
                            </div>
                            <hr className="my-2" />
                            <div className="flex justify-between font-bold">
                                <span>Total</span>
                                <span>${total}</span>
                            </div>
                        </div>

                        <button
                            onClick={handleCheckout}
                            className="w-full mt-6 bg-[#20bcb4] text-white py-3 rounded-lg font-bold"
                        >
                            Checkout
                        </button>
                    </>
                )}
            </div>
        </section>
    );
}